var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundColorButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74548 8.54406L5.76706 5.85553H5.74308L4.75987 8.54406H6.74548Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92533 9.61859C9.92533 10.1669 10.4193 10.4234 10.9469 10.4234C11.652 10.4234 12.1795 10.0166 12.1795 9.43729V8.89782H10.9133C10.2227 8.89782 9.92533 9.19851 9.92533 9.61859Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55523 1.3335C2.32793 1.3335 1.33301 2.32842 1.33301 3.55572V12.4446C1.33301 13.6719 2.32793 14.6668 3.55523 14.6668H12.4441C13.6714 14.6668 14.6663 13.6719 14.6663 12.4446V3.55572C14.6663 2.32842 13.6714 1.3335 12.4441 1.3335H3.55523ZM4.53445 9.16755L3.87258 10.9805H2.99967L5.33061 4.94461H6.18433L8.51526 10.9805H7.63277L6.9709 9.16755H4.53445ZM12.2083 10.4013H12.1843C11.9301 10.7771 11.4697 11.0557 10.7263 11.0557C9.75267 11.0557 9.08121 10.4986 9.08121 9.64512C9.08121 8.83149 9.69512 8.31854 10.851 8.31412H12.1795V7.84097C12.1795 7.23075 11.7958 6.89468 11.1148 6.89468C10.4673 6.89468 10.098 7.19979 10.05 7.6641H9.27306C9.32581 6.85046 9.92533 6.25792 11.1436 6.25792C12.2179 6.25792 12.9997 6.7974 12.9997 7.77464V10.9805H12.2083V10.4013Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundColorButton);
export default __webpack_public_path__ + "static/media/backgroundColorButton.44772f6a28598a497054ded09da2152c.svg";
export { ForwardRef as ReactComponent };